import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OutlineClock } from '../../../../../icons/outlineClock';
import STRING_KEYS from '../../../../../language/keys';
import { style } from './style';

export const CandidatePendingPromotion = ():JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box sx={ style.Box.sx }>
      <Box sx={ style.BoxWrapper.sx }>
        <OutlineClock />
      </Box>
      {translate(STRING_KEYS.PENDING_PROMOTION_TEXT)}
    </Box>
  );
};
